import React, {useMemo, useState}							from 'react';
import moment										from 'moment';
import {useNavigate}								from 'react-router-dom';

import ContractDocument								from './ContractsDocuments';
import ContractAddDeviceModal						from './ContractsAddDeviceModal';
import Button										from '../ressources/components/Button';
import Input										from '../ressources/components/Input';
import MultiInputContainer							from '../ressources/components/Input/MultiInputContainer';
import Tabs											from '../ressources/components/Tabs';
import Select										from '../ressources/components/Select';
import Icon											from '../ressources/components/Icon';
import DeviceFilterModal							from '../ressources/components/ModalFilter/ModalFilter';
import FiltersBadge									from '../ressources/components/ModalFilter/FilterBadge';
import ModalAssign									from '../ressources/components/ModalAssign';
import ButtonStickyContainer						from '../ressources/components/Button/ButtonStickyContainer';
import UsersModalAssignDevice						from '../Users/UserAssignDevice';

import {useAppSelector, useAppDispatch}				from '../app/hooks';
import {pushUpload, setUploadPercent}				from '../redux/documents/documents';
import {assignDevicesApi, getDevicesApi}			from '../redux/devices/devices';
import {InputValues}								from '../ressources/components/Input/interface';
import {FilterChecked} 								from '../ressources/components/Modal/interface';
import {User}										from '../redux/user/interface';
import {PostContactNotValalaState}					from '../redux/contractsNotValala/interface';
import {postContractNotValalaApi}					from '../redux/contractsNotValala/contractsNotValala';

import {ft_genNotification, ft_pushNotification} 	from '../ressources/functions/notification';
import {ft_selectDataStringIcon}					from '../ressources/functions/selectData';
import {ft_formatPrice, ft_formatUserName}			from '../ressources/functions/format';
import {ft_getDeviceName}							from '../ressources/functions/deviceFunction';

import img_deviceIcon								from '../ressources/images/icon/devices/computer.svg';
import img_addCircle								from '../ressources/images/icon/add-circle.svg';
import img_box										from '../ressources/images/icon/box.svg';
import img_cursorClick								from '../ressources/images/icon/cursor-click.svg';
import img_plusSquare								from '../ressources/images/icon/plus-square.svg';
import img_penLine									from '../ressources/images/icon/pen-line.svg';
import img_upload									from '../ressources/images/icon/upload.svg';
import img_file										from '../ressources/images/icon/file.svg';

import LANGUAGE										from '../ressources/language';
import * as API										from '../ressources/API';

import './Contracts.css';


function ContractAdd() {
	const dispatch = useAppDispatch();
	const user = useAppSelector(state => state.user.data);
	const devices = useAppSelector(state => state.devices.data);
	const mobileLines = useAppSelector(state => state.mobileLines.data);
	const lang = useAppSelector(state => state.settings.lang);
	const documentsUpload = useAppSelector(state => state.documents.uploadDocument);
	let notificationId = useAppSelector(state => state.notifications.lastId);

	const [step, set_step] = useState<number>(1);
	const [step2View, set_step2View] = useState<'default' | 'list' | 'confirm'>('default');
	const [modal, set_modal] = useState(false);

	const [name, set_name] = useState<InputValues>('');
	const [funder, set_funder] = useState<InputValues>('');
	const [contractStart, set_contractStart] = useState<InputValues>('');
	const [duration, set_duration] = useState<InputValues>('');
	const [price, set_price] = useState<InputValues>('');
	const [contractNumber, set_contractNumber] = useState<InputValues>('');
	const [billingNumber, set_billingNumber] = useState<InputValues>('');
	const [error, set_error] = useState<{[key: string]: string}>({});

	const [filterModal, set_filterModal] = useState(false);
	const [filters, set_filters] = useState<FilterChecked[]>([]);
	const [selectedDevices, set_selectedDevices] = useState<{[key: string]: boolean}>({});

	const [assignDeviceId, set_assignDeviceId] = useState('');
	const [assignUser, set_assignUser] = useState<User>();

	const [documents, set_documents] = useState<File[]>([]);

	const [load, set_load] = useState(false);

	const TEXTE = LANGUAGE(lang);
	const navigate = useNavigate();

	const devicesWithLines = useMemo(() => [...devices, ...mobileLines], [devices, mobileLines]);

	function addContract() {
		set_load(true);

		const apiData: PostContactNotValalaState = {
			name,
			price,
			billingNumber,
			funder,
			duration,
			number:        contractNumber,
			devices:       Object.entries(selectedDevices).filter(e => e[1]).map(e => e[0]),
			locationStart: contractStart ? moment(contractStart, 'DD/MM/YYYY').toDate() : undefined,
			locationEnd:   contractStart ? moment(contractStart, 'DD/MM/YYYY').add(duration, 'month').toDate() : undefined
		};

		// --- Post Contract
		dispatch(postContractNotValalaApi({data: apiData, user}))
		.then((response) => {
			if (!response.payload?._id) {
				const notificationData = ft_genNotification(TEXTE, 'error', img_deviceIcon, response.payload.error, 'error');
				ft_pushNotification(dispatch, notificationId, notificationData);

				return set_load(false);
			}

			let notificationData = ft_genNotification(TEXTE, 'addContractSuccess', img_penLine, name as string);
			notificationId = ft_pushNotification(dispatch, notificationId, notificationData);

			// --- Upload Documents
			documents.map((document, i) => {
				if (document.size > 2097152)
					return;

				const index = documentsUpload.length + i;
				const dispatchData = {index, dispatch, function: setUploadPercent};

				const uploadFileData = {
					percent:  0,
					filename: document.name,
					size:     document.size,
					id:       response.payload._id
				};

				dispatch(pushUpload(uploadFileData));

				API.uploadContractNotValalaDocument(response.payload._id, document, user, dispatchData)
				.then((responseUpload) => {
					if (!responseUpload || !responseUpload.status)
						return dispatch(setUploadPercent({index, percent: `error: ${responseUpload?.error || ''}`}));

					notificationData = ft_genNotification(TEXTE, 'fileDownloadDone', img_upload, name as string);
					notificationId = ft_pushNotification(dispatch, notificationId, notificationData);
				});
			});

			set_load(false);
			navigate(`/contracts/${response.payload._id}`);
			dispatch(getDevicesApi(user));
		});
	}

	function assignDevice() {
		if (!assignDeviceId || !assignUser)
			return;

		set_load(true);

		dispatch(assignDevicesApi({
			user,
			assignUser,
			devicesId:  [assignDeviceId]
		}))
		.then(() => {
			const notificationData = ft_genNotification(TEXTE, 'assignDeviceSuccess', img_deviceIcon, ft_formatUserName(assignUser));
			ft_pushNotification(dispatch, notificationId, notificationData);

			set_assignUser(undefined);
			set_assignDeviceId('');
			set_load(false);
		});
	}

	function previousButton() {
		if (step === 1)
			return navigate('/contracts');
		else if (step2View !== 'default')
			return set_step2View('default');
		return set_step(step - 1);
	}

	function checkStepIsValid() {
		const newError: {[key: string]: string} = {};

		if (step === 1) {
			if (!name)
				newError.name = 'required';
			if (!contractStart)
				newError.contractStart = 'required';
			if (!duration)
				newError.duration = 'required';
			if (!price)
				newError.price = 'required';
		}

		set_error(newError);

		if (step === 2 && step2View === 'list')
			return set_step2View('confirm');
		set_step2View('default');
		if (Object.keys(newError).length === 0 && step < 3)
			return set_step(step + 1);
		if (step === 3)
			addContract();
	}

	function renderStep1() {
		return (
			<div>
				<Input
					required
					value={name}
					error={error.name}
					onChange={set_name}
					title={TEXTE.contract.contractName}
					placeholder={'ex : Contrat BackMarket'}
				/>

				<MultiInputContainer>
					<Input
						value={funder}
						error={error.funder}
						onChange={set_funder}
						title={TEXTE.global.supplier}
						placeholder={'Apple Pro Services'}
					/>
					<Input
						required
						type={'date'}
						value={contractStart}
						error={error.contractStart}
						onChange={set_contractStart}
						title={TEXTE.global.contractStart}
						placeholder={moment().startOf('month').format('DD/MM/YYYY')}
					/>

				</MultiInputContainer>

				<MultiInputContainer>
					<Input
						required
						min={1}
						type={'number'}
						value={duration}
						error={error.duration}
						onChange={set_duration}
						title={TEXTE.global.duration}
						placeholder={`24 ${TEXTE.global.month}`}
						notFocusValue={duration ? `${duration} ${TEXTE.global.month}` : undefined}
					/>
					<Input
						readOnly
						title={TEXTE.global.contractEnd}
						value={(contractStart && duration) ? moment(contractStart, 'DD/MM/YYYY').add(duration, 'month').format('DD/MM/YYYY') : ''}
					/>
				</MultiInputContainer>

				<MultiInputContainer>
					<Input
						required
						min={0}
						value={price}
						type={'number'}
						error={error.price}
						onChange={set_price}
						title={TEXTE.global.monthlyPrice}
						placeholder={ft_formatPrice('24')}
						notFocusValue={price ? ft_formatPrice(price) : undefined}
					/>
					<Input
						error={error.billingNumber}
						value={billingNumber}
						onChange={set_billingNumber}
						title={TEXTE.global.billingNumber}
						placeholder={'123456'}
					/>
				</MultiInputContainer>

				<Input
					value={contractNumber}
					onChange={set_contractNumber}
					title={TEXTE.global.contractNumber}
					placeholder={'123456'}
				/>
			</div>
		);
	}

	function renderStep2() {
		if (step2View === 'confirm') {
			const selectData = ft_selectDataStringIcon([
				{value: 'list', icon: img_box, text: TEXTE.contract.fromInventory},
				{value: 'manual', icon: img_cursorClick, text: TEXTE.contract.manual}
			]);

			return (
				<div>
					<div className={'addContractStep2Confirm'}>
						<span className={'text-md gray-900 weight-500'}>{TEXTE.contract.yourSelection}</span>
						<div className={'flex'} />
						<Select
							notFullWidth
							type={'primary'}
							data={selectData}
							icon={img_plusSquare}
							placeholder={TEXTE.contract.addDevices}
							onChange={val => (val === 'manual' ? set_modal(true) : set_step2View('list'))}
						/>
					</div>
					{filters.length > 0 && <FiltersBadge filters={filters} setFilters={set_filters} />}

					<UsersModalAssignDevice
						hideFilter
						noValidation
						deviceList={devicesWithLines.filter(device => selectedDevices[device._id])}
						deleteAction={(deviceId) => {
							const device = devicesWithLines.find(find => find._id === deviceId);

							set_selectedDevices({...selectedDevices, [deviceId]: false});

							if (device) {
								const notificationData = ft_genNotification(TEXTE, 'removeDeviceInventorySuccess', img_deviceIcon, ft_getDeviceName(device));
								ft_pushNotification(dispatch, notificationId, notificationData);
							}
						}}
					/>
				</div>
			);
		}

		return (
			<div className={'addContractStep step2 center'}>
				<Icon
					iconBorder
					size={32}
					iconSize={20}
					borderSize={8}
					icon={img_addCircle}
				/>
				<span className={'text-lg weight-600 gray-900'}>{TEXTE.contract.addContractChoice}</span>
				<span className={'text-md weight-400 gray-600'}>{TEXTE.contract.addContractChoiceText}</span>

				<MultiInputContainer>
					<Button onClick={() => set_step2View('list')}>{TEXTE.global.select}</Button>
					<Button type={'secondary-gray'} onClick={() => set_modal(true)}>{TEXTE.contract.manualAdd}</Button>
				</MultiInputContainer>

				{step2View === 'list' &&
					<UsersModalAssignDevice
						modal
						noValidation
						onClose={() => set_step2View(Object.values(selectedDevices).find(e => e) ? 'confirm' : 'default')}
						deviceList={devicesWithLines.filter(device => !selectedDevices[device._id] && device.notValala && !device.contract && !device.contractNotValala)}
						onSave={(idList) => {
							const newSelected: {[key: string]: boolean} = {};

							idList.forEach(id => newSelected[id] = true);
							set_selectedDevices({...selectedDevices, ...newSelected});
							checkStepIsValid();
						}}
					/>
				}
			</div>
		);
	}

	function renderStep3() {
		return (
			<div className={'addContractStep step3'}>
				<ContractDocument documents={documents} setDocument={set_documents} />
			</div>
		);
	}

	function renderButtonContainer() {
		return (
			<ButtonStickyContainer>
				<Button
					fullWidth
					disabled={load}
					type={'tertiary-gray'}
					onClick={previousButton}
				>
					{step === 1 ? TEXTE.global.cancel : TEXTE.global.previous}
				</Button>
				<Button
					fullWidth
					isLoad={load}
					onClick={checkStepIsValid}
					disabled={(step === 2 && step2View === 'default') || (step2View === 'confirm' && Object.values(selectedDevices).filter(e => e).length === 0)}
				>
					{(step === 1 || (step === 2 && step2View === 'default')) && TEXTE.global.next}
					{(step === 2 && step2View === 'list') && `${TEXTE.contract.addSelection} (${Object.values(selectedDevices).filter(e => e).length})`}
					{(step === 2 && step2View === 'confirm') && TEXTE.contract.confirmSelection}
					{step === 3 && TEXTE.global.validAndSave}
				</Button>
			</ButtonStickyContainer>
		);
	}

	return (
		<div className={'globalDataContainer'}>
			<div className={'globalAddHeader'}>
				<Icon
					iconSize={24}
					icon={img_file}
					iconColor={'#000000'}
				/>
				<div className={'globalAddHeaderText'}>
					<span>{TEXTE.contract.addContract}</span>
					<span>{TEXTE.contract.setContractDescription}</span>
				</div>

			</div>

			<div className={'globalAddContainer'}>
				<Tabs
					step
					actual={step}
					onChange={val => set_step(val as number)}
					data={[
						{value: 1, render: TEXTE.contract.aboutContract},
						{value: 2, render: TEXTE.contract.deviceLinkToContract},
						{value: 3, render: TEXTE.contract.contractDocument}
					]}
				/>

				{step === 1 && renderStep1()}
				{step === 2 && renderStep2()}
				{step === 3 && renderStep3()}
			</div>

			{renderButtonContainer()}

			{filterModal &&
				<DeviceFilterModal
					filters={filters}
					setFilters={set_filters}
					onClose={() => set_filterModal(false)}
				/>
			}

			{modal &&
				<ContractAddDeviceModal
					onClose={() => set_modal(false)}
					onConfirm={(idList) => {
						const copy = {...selectedDevices};
						idList.forEach(id => copy[id] = true);

						set_selectedDevices(copy);
						set_step2View('confirm');
						set_modal(false);
					}}
				/>
			}
			{assignDeviceId &&
				<ModalAssign
					load={load}
					onConfirm={assignDevice}
					onChange={set_assignUser}
					actualId={assignUser?._id ? [assignUser._id] : []}
					onClose={() => {
						set_assignUser(undefined);
						set_assignDeviceId('');
					}}
				/>
			}
		</div>
	);
}

export default ContractAdd;
